import React from "react";
import { MobileTabBar } from "../../../ForBrands/ui/mobile/MobileShell";
import { usePhoneTheme } from "../../../ForBrands/useIsPhone";
import { TEAM_TABS } from "./teamModel";

// Roster / Performance / NIL Intelligence (Figma sub tabs: 44px high, text
// flush left, the brand underline running 28px past the label). On phones
// it is the TabBar · Mobile (2407:871, 2409:985, 2411:1271): 13px labels,
// sticky under the 55px top bar (D-c2); `className` places it on the page
// (the Team page bleeds it to the screen edges).
const TeamSubTabs = ({ value, onChange, className = "" }) => {
  const phone = usePhoneTheme();
  if (phone) return <MobileTabBar tabs={TEAM_TABS} value={value} onChange={onChange} ariaLabel="Team views" sticky className={className} />;
  return (
    <div role="tablist" aria-label="Team views" className="flex overflow-x-auto border-b border-bm-border">
      {TEAM_TABS.map((t) => {
        const active = value === t.value;
        return (
          <button
            key={t.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(t.value)}
            className={`-mb-px h-11 shrink-0 border-b-2 pr-7 text-left font-archivo text-[15px] font-bold leading-5 ${
              active ? "border-bm-orange text-bm-orange" : "border-transparent text-bm-muted hover:text-bm-ink"
            }`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
};

export default TeamSubTabs;
